import StateTree from "./StateTree";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const getLanguage = () => {
    let language = cookies.get("language");

    if (!language) {
        cookies.set("language", "en", { path: "/" });
        language = "en";
    }

    return language;
};

const setLanguage = (defaultLanguage) => {
    if (defaultLanguage) {
        cookies.set("language", defaultLanguage, { path: "/" });
        StateTree.update("language", defaultLanguage);
        return;
    }

    let language = cookies.get("language");

    if (language) {
        if (language == "en") {
            language = "es";
        } else {
            language = "en";
        }
    } else {
        language = "es";
    }

    cookies.set("language", language, { path: "/" });
    StateTree.update("language", language);
};

const subscribe = (callback) => {
    StateTree.subscribe("language", callback);
};

export { getLanguage, setLanguage, subscribe };
